// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Belt_SortArray from "@rescript/runtime/lib/es6/Belt_SortArray.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as S3Utils$OrcaPaymentPage from "./S3Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as Constants$OrcaPaymentPage from "./Constants.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./JotaiAtoms.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./PaymentBody.bs.js";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";
import * as PayPalHelpers$OrcaPaymentPage from "../Payments/PayPalHelpers.bs.js";
import * as SdkConfigTypes$OrcaPaymentPage from "../../shared-code/sdk-utils/types/SdkConfigTypes.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";
import * as PaymentModeType$OrcaPaymentPage from "../Types/PaymentModeType.bs.js";
import * as SdkConfigParser$OrcaPaymentPage from "../../shared-code/sdk-utils/utils/SdkConfigParser.bs.js";
import * as UnifiedHelpersV2$OrcaPaymentPage from "./UnifiedHelpersV2.bs.js";
import * as CountryStateDataRefs$OrcaPaymentPage from "../CountryStateDataRefs.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";

let paymentMethodListValue = Jotai.atom(PaymentMethodsRecord$OrcaPaymentPage.defaultList);

let sdkConfigsValue = Jotai.atom(SdkConfigTypes$OrcaPaymentPage.defaultSdkConfigValue);

let paymentManagementListValue = Jotai.atom(UnifiedHelpersV2$OrcaPaymentPage.defaultPaymentsList);

function paymentListLookupNew(list, order, isShowPaypal, isShowKlarnaOneClick, isKlarnaSDKFlow, paymentMethodListValue, areAllGooglePayRequiredFieldsPrefilled, collectBillingDetailsFromWalletConnector, isGooglePayReady, shouldDisplayApplePayInTabs, shouldDisplayPayPalInTabs, showWalletsWithOtherPaymentMethods, showGroupedSavedPaymentMethods) {
  let pmList = PaymentMethodsRecord$OrcaPaymentPage.buildFromPaymentList(list);
  let walletsList = [];
  let walletToBeDisplayedInTabs = [
    "mb_way",
    "ali_pay",
    "ali_pay_hk",
    "mobile_pay",
    "we_chat_pay",
    "vipps",
    "twint",
    "dana",
    "go_pay",
    "kakao_pay",
    "gcash",
    "momo",
    "touch_n_go",
    "mifinity",
    "bluecode",
    "revolut_pay",
    "skrill"
  ];
  let otherPaymentList = [];
  if (shouldDisplayApplePayInTabs) {
    walletToBeDisplayedInTabs.push("apple_pay");
  }
  if (shouldDisplayPayPalInTabs) {
    walletToBeDisplayedInTabs.push("paypal");
  }
  let requiresGooglePayBillingDetails = !collectBillingDetailsFromWalletConnector && !areAllGooglePayRequiredFieldsPrefilled;
  let shouldDisplayGooglePayInTabs = isGooglePayReady && (showWalletsWithOtherPaymentMethods || requiresGooglePayBillingDetails);
  if (shouldDisplayGooglePayInTabs) {
    walletToBeDisplayedInTabs.push("google_pay");
  }
  if (showGroupedSavedPaymentMethods) {
    otherPaymentList.push("saved_methods");
  }
  pmList.forEach(item => {
    if (walletToBeDisplayedInTabs.includes(item.paymentMethodName)) {
      otherPaymentList.push(item.paymentMethodName);
      return;
    }
    if (item.methodType === "wallet") {
      if (item.paymentMethodName !== "paypal" || isShowPaypal) {
        walletsList.push(item.paymentMethodName);
        return;
      } else {
        return;
      }
    }
    if (item.methodType === "bank_debit") {
      otherPaymentList.push(item.paymentMethodName + "_debit");
      return;
    }
    if (item.methodType === "bank_transfer" && !Constants$OrcaPaymentPage.bankTransferList.includes(item.paymentMethodName)) {
      otherPaymentList.push(item.paymentMethodName + "_transfer");
      return;
    }
    if (item.methodType === "card") {
      otherPaymentList.push("card");
      return;
    }
    if (item.methodType === "reward") {
      otherPaymentList.push(item.paymentMethodName);
      return;
    }
    if (item.methodType === "pay_later") {
      if (item.paymentMethodName === "klarna") {
        let klarnaPaymentMethodExperience = PaymentMethodsRecord$OrcaPaymentPage.getPaymentExperienceTypeFromPML(paymentMethodListValue, item.methodType, item.paymentMethodName);
        let isInvokeSDKExperience = klarnaPaymentMethodExperience.includes("InvokeSDK");
        let isRedirectExperience = klarnaPaymentMethodExperience.includes("RedirectToURL");
        if (isKlarnaSDKFlow && isShowKlarnaOneClick && isInvokeSDKExperience) {
          walletsList.push(item.paymentMethodName);
          return;
        } else if (isRedirectExperience) {
          otherPaymentList.push(item.paymentMethodName);
          return;
        } else {
          return;
        }
      }
      otherPaymentList.push(item.paymentMethodName);
      return;
    }
    otherPaymentList.push(item.paymentMethodName);
  });
  let updatedWalletsList = showWalletsWithOtherPaymentMethods ? [] : walletsList;
  return [
    Utils$OrcaPaymentPage.sortBasedOnPriority(Utils$OrcaPaymentPage.removeDuplicate(updatedWalletsList), order),
    Utils$OrcaPaymentPage.sortBasedOnPriority(Utils$OrcaPaymentPage.removeDuplicate(otherPaymentList), order)
  ];
}

function getDisplayNameAndIcon(customNames, paymentMethodName, defaultName, defaultIcon) {
  let customNameObj = customNames.filter(item => item.paymentMethodName === paymentMethodName)[0];
  if (customNameObj === undefined) {
    return [
      defaultName,
      defaultIcon
    ];
  }
  if (customNameObj.paymentMethodName !== "classic" && customNameObj.paymentMethodName !== "evoucher") {
    return [
      defaultName,
      defaultIcon
    ];
  }
  let aliasName = customNameObj.aliasName;
  if (aliasName === "") {
    return [
      defaultName,
      defaultIcon
    ];
  }
  let id = aliasName.split(" ");
  return [
    aliasName,
    PaymentMethodsRecord$OrcaPaymentPage.icon(19, undefined, Core__Option.getOr(id[0], ""))
  ];
}

function getPaymentMethodName(paymentMethodType, paymentMethodName) {
  if (paymentMethodType === "bank_debit") {
    return paymentMethodName.replace("_debit", "");
  } else if (paymentMethodType === "bank_transfer" && !Constants$OrcaPaymentPage.bankTransferList.includes(paymentMethodName)) {
    return paymentMethodName.replace("_transfer", "");
  } else {
    return paymentMethodName;
  }
}

function isAppendingCustomerAcceptance(isGuestCustomer, paymentType, alwaysSendOpt) {
  let alwaysSend = alwaysSendOpt !== undefined ? alwaysSendOpt : false;
  if (isGuestCustomer) {
    return false;
  } else if (alwaysSend || paymentType === "NEW_MANDATE") {
    return true;
  } else {
    return paymentType === "SETUP_MANDATE";
  }
}

function appendedCustomerAcceptance(isGuestCustomer, paymentType, body, alwaysSendOpt) {
  let alwaysSend = alwaysSendOpt !== undefined ? alwaysSendOpt : false;
  if (isAppendingCustomerAcceptance(isGuestCustomer, paymentType, alwaysSend)) {
    return body.concat([[
        "customer_acceptance",
        PaymentBody$OrcaPaymentPage.customerAcceptanceBody
      ]]);
  } else {
    return body;
  }
}

function getIsKlarnaSDKFlow(sessions) {
  let dict = Utils$OrcaPaymentPage.getDictFromJson(sessions);
  let sessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "Others");
  let klarnaTokenObj = SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Klarna");
  if (klarnaTokenObj.TAG === "OtherTokenOptional") {
    return Core__Option.isSome(klarnaTokenObj._0);
  } else {
    return false;
  }
}

function usePaypalFlowStatus(sessions, paymentMethodListValue) {
  let sessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(sessions), "Others");
  let match = PayPalHelpers$OrcaPaymentPage.usePaymentMethodData(paymentMethodListValue, sessionObj);
  let paypalToken = match.paypalToken;
  let isPaypalTokenExist;
  isPaypalTokenExist = paypalToken.TAG === "OtherTokenOptional" ? paypalToken._0 !== undefined : false;
  return [
    match.isPaypalSDKFlow,
    match.isPaypalRedirectFlow,
    isPaypalTokenExist
  ];
}

function filterSavedMethodsByHiddenList(savedMethods, hiddenPaymentMethods) {
  if (hiddenPaymentMethods.length === 0) {
    return savedMethods;
  }
  let lowerHidden = hiddenPaymentMethods.map(paymentMethod => paymentMethod.toLowerCase());
  return savedMethods.filter(savedMethod => {
    let pmt = savedMethod.paymentMethodType;
    let paymentMethodTypeLower = pmt !== undefined ? pmt.toLowerCase() : "";
    let paymentMethodLower = savedMethod.paymentMethod.toLowerCase();
    let hiddenByType = lowerHidden.includes(paymentMethodTypeLower);
    let hiddenByMethod = paymentMethodLower === "card" && lowerHidden.includes("card");
    return !(hiddenByType || hiddenByMethod);
  });
}

function filterSavedMethodsByWalletReadiness(savedMethods, isApplePayReady, isGooglePayReady) {
  return savedMethods.filter(savedMethod => {
    let match = savedMethod.paymentMethodType;
    if (match === undefined) {
      return true;
    }
    switch (match) {
      case "apple_pay" :
        return isApplePayReady;
      case "google_pay" :
        return isGooglePayReady;
      default:
        return true;
    }
  });
}

function useGetPaymentMethodList(paymentType, sessions, areAllApplePayRequiredFieldsPrefilled, areAllGooglePayRequiredFieldsPrefilled, areAllPaypalRequiredFieldsPrefilled) {
  let methodslist = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodList);
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let paymentMethodOrder = match.paymentMethodOrder;
  let optionAtomValue = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let paymentOrder = Utils$OrcaPaymentPage.removeDuplicate(Utils$OrcaPaymentPage.getOptionalArr(paymentMethodOrder));
  let isKlarnaSDKFlow = getIsKlarnaSDKFlow(sessions);
  let paymentMethodListValue$1 = Jotai.useAtomValue(paymentMethodListValue);
  let sdkConfigsValue$1 = Jotai.useAtomValue(sdkConfigsValue);
  let isApplePayReady = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isApplePayReady);
  let isGooglePayReady = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isGooglePayReady);
  let isVgsScriptReady = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isVgsScriptReady);
  let match$1 = usePaypalFlowStatus(sessions, paymentMethodListValue$1);
  let isPaypalTokenExist = match$1[2];
  let isPaypalRedirectFlow = match$1[1];
  let isPaypalSDKFlow = match$1[0];
  let layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(optionAtomValue.layout);
  let match$2 = layoutClass.savedMethodCustomization.groupingBehavior;
  let displayGroupedSavedMethods = !match$2.displayInSeparateScreen && !match$2.groupByPaymentMethods;
  let showWalletsWithOtherPaymentMethods = !layoutClass.displayOneClickPaymentMethodsOnTop && paymentType === "Payment";
  let processPaymentsList = (paymentList, savedPaymentMethods) => {
    let paymentOrder$1 = paymentOrder.length > 0 ? paymentOrder : PaymentModeType$OrcaPaymentPage.defaultOrder;
    let pList = PaymentMethodsRecord$OrcaPaymentPage.itemToObjMapperFromClientList(Utils$OrcaPaymentPage.getDictFromJson(paymentList));
    let collectBillingDetailsFromWalletConnector = SdkConfigParser$OrcaPaymentPage.getCollectBillingDetailsFromWalletConnector(Core__Option.flatMap(sdkConfigsValue$1.account_config, ac => ac.profile));
    let requiresApplePayBillingDetails = !collectBillingDetailsFromWalletConnector && !areAllApplePayRequiredFieldsPrefilled;
    let shouldDisplayApplePayInTabs = isApplePayReady && (showWalletsWithOtherPaymentMethods || requiresApplePayBillingDetails);
    let match = optionAtomValue.wallets.payPal;
    let isShowPaypal;
    isShowPaypal = match.TAG === "PaypalConfigString" ? match._0 === "Auto" : match._0.display === "Auto";
    let requiresPaypalBillingDetails = !collectBillingDetailsFromWalletConnector && !areAllPaypalRequiredFieldsPrefilled;
    let isPaypalEligibleInRedirectFlow = isShowPaypal && isPaypalRedirectFlow && (!isPaypalSDKFlow || !isPaypalTokenExist);
    let shouldDisplayPayPalInTabs = isPaypalEligibleInRedirectFlow && (showWalletsWithOtherPaymentMethods || requiresPaypalBillingDetails);
    let filteredSaved = savedPaymentMethods !== undefined ? filterSavedMethodsByWalletReadiness(filterSavedMethodsByHiddenList(savedPaymentMethods, layoutClass.savedMethodCustomization.hiddenPaymentMethods), isApplePayReady, isGooglePayReady) : [];
    let showGroupedSavedPaymentMethods = displayGroupedSavedMethods && filteredSaved.length > 0 && optionAtomValue.displaySavedPaymentMethods;
    let match$1 = paymentListLookupNew(pList, paymentOrder$1, isShowPaypal, optionAtomValue.wallets.klarna === "Auto", isKlarnaSDKFlow, pList, areAllGooglePayRequiredFieldsPrefilled, collectBillingDetailsFromWalletConnector, isGooglePayReady, shouldDisplayApplePayInTabs, shouldDisplayPayPalInTabs, showWalletsWithOtherPaymentMethods, showGroupedSavedPaymentMethods);
    let otherOptions = match$1[1];
    let klarnaPaymentMethodExperience = PaymentMethodsRecord$OrcaPaymentPage.getPaymentExperienceTypeFromPML(pList, "pay_later", "klarna");
    let isKlarnaInvokeSDKExperience = klarnaPaymentMethodExperience.includes("InvokeSDK");
    let filterPaymentMethods = paymentOptionsList => paymentOptionsList.filter(paymentOptionsName => {
      switch (paymentOptionsName) {
        case "apple_pay" :
          return shouldDisplayApplePayInTabs;
        case "card" :
          return isVgsScriptReady;
        case "klarna" :
          return !(isKlarnaSDKFlow && isKlarnaInvokeSDKExperience);
        case "paypal" :
          return shouldDisplayPayPalInTabs;
        default:
          return true;
      }
    });
    return [
      Utils$OrcaPaymentPage.getWalletPaymentMethod(Utils$OrcaPaymentPage.removeDuplicate(match$1[0]), paymentType),
      filterPaymentMethods(Utils$OrcaPaymentPage.removeDuplicate(otherOptions)),
      otherOptions
    ];
  };
  return React.useMemo(() => {
    let match = optionAtomValue.customerPaymentMethods;
    if (typeof methodslist !== "object") {
      if (methodslist === "Loading") {
        return [
          [],
          [],
          []
        ];
      } else if (Utils$OrcaPaymentPage.checkPriorityList(paymentMethodOrder)) {
        return [
          [],
          ["card"],
          []
        ];
      } else {
        return [
          [],
          [],
          []
        ];
      }
    }
    if (methodslist.TAG !== "Loaded") {
      return [
        [],
        [],
        []
      ];
    }
    let paymentlist = methodslist._0;
    if (typeof match === "object") {
      if (match.TAG !== "LoadedSavedCards") {
        return processPaymentsList(paymentlist, undefined);
      }
      if (displayGroupedSavedMethods) {
        return processPaymentsList(paymentlist, match._0);
      }
    }
    if (displayGroupedSavedMethods) {
      return [
        [],
        [],
        []
      ];
    } else {
      return processPaymentsList(paymentlist, undefined);
    }
  }, [
    methodslist,
    paymentMethodOrder,
    optionAtomValue.wallets.payPal,
    optionAtomValue.wallets.klarna,
    paymentType,
    showWalletsWithOtherPaymentMethods,
    isKlarnaSDKFlow,
    areAllApplePayRequiredFieldsPrefilled,
    areAllGooglePayRequiredFieldsPrefilled,
    areAllPaypalRequiredFieldsPrefilled,
    isPaypalSDKFlow,
    isPaypalRedirectFlow,
    isPaypalTokenExist,
    isApplePayReady,
    isGooglePayReady,
    isVgsScriptReady,
    optionAtomValue.customerPaymentMethods,
    optionAtomValue.displaySavedPaymentMethods,
    displayGroupedSavedMethods,
    layoutClass.savedMethodCustomization.hiddenPaymentMethods,
    sdkConfigsValue$1.account_config
  ]);
}

function useStatesJson(setStatesJson) {
  let stateList = CountryStateDataRefs$OrcaPaymentPage.stateDataRef.contents;
  React.useEffect(() => {
    setStatesJson(param => stateList);
  }, []);
}

async function getStateJson(param) {
  try {
    return (await S3Utils$OrcaPaymentPage.getCountryStateData(undefined, undefined)).states;
  } catch (raw_err) {
    let err = Primitive_exceptions.internalToException(raw_err);
    console.error("Error importing states:", err);
    return null;
  }
}

function sortCustomerMethodsBasedOnPriority(sortArr, priorityArr, displayDefaultSavedPaymentIconOpt) {
  let displayDefaultSavedPaymentIcon = displayDefaultSavedPaymentIconOpt !== undefined ? displayDefaultSavedPaymentIconOpt : true;
  if (priorityArr.length === 0) {
    return sortArr;
  }
  let getPaymentMethod = customerMethod => {
    if (customerMethod.paymentMethod === "card") {
      return customerMethod.paymentMethod;
    }
    let paymentMethodType = customerMethod.paymentMethodType;
    if (paymentMethodType !== undefined) {
      return paymentMethodType;
    } else {
      return customerMethod.paymentMethod;
    }
  };
  let getCustomerMethodPriority = paymentMethod => {
    let priorityArrLength = priorityArr.length;
    let index = priorityArr.indexOf(paymentMethod);
    if (index === -1) {
      return priorityArrLength;
    } else {
      return index;
    }
  };
  let handleCustomerMethodsSort = (firstCustomerMethod, secondCustomerMethod) => {
    let firstPaymentMethod = getPaymentMethod(firstCustomerMethod);
    let secondPaymentMethod = getPaymentMethod(secondCustomerMethod);
    if (displayDefaultSavedPaymentIcon && (firstCustomerMethod.defaultPaymentMethodSet || secondCustomerMethod.defaultPaymentMethodSet)) {
      if (firstCustomerMethod.defaultPaymentMethodSet) {
        return -1;
      } else {
        return 1;
      }
    } else {
      return getCustomerMethodPriority(firstPaymentMethod) - getCustomerMethodPriority(secondPaymentMethod) | 0;
    }
  };
  return Belt_SortArray.stableSortBy(sortArr, handleCustomerMethodsSort);
}

function getSupportedCardBrands(paymentMethodListValue) {
  let cardPaymentMethod = paymentMethodListValue.payment_methods.find(ele => ele.payment_method === "card");
  if (cardPaymentMethod === undefined) {
    return;
  }
  let cardNetworks = cardPaymentMethod.payment_method_types.map(ele => ele.card_networks);
  let cardNetworkNames = cardNetworks.map(ele => ele.map(val => CardUtils$OrcaPaymentPage.getCardStringFromType(val.card_network).toLowerCase()));
  return Utils$OrcaPaymentPage.getUniqueArray(Core__Array.reduce(cardNetworkNames, [], (acc, ele) => acc.concat(ele)));
}

function checkIsCardSupported(cardNumber, cardBrand, supportedCardBrands) {
  let clearValue = CardValidations$OrcaPaymentPage.clearSpaces(cardNumber);
  if (cardBrand === "") {
    return CardUtils$OrcaPaymentPage.cardValid(clearValue, cardBrand);
  } else if (CardUtils$OrcaPaymentPage.cardValid(clearValue, cardBrand)) {
    if (supportedCardBrands !== undefined) {
      return supportedCardBrands.includes(cardBrand.toLowerCase());
    } else {
      return true;
    }
  } else {
    return;
  }
}

function emitMessage(paymentMethodInfo) {
  Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
      "paymentMethodInfo",
      paymentMethodInfo
    ]]);
}

function emitPaymentMethodInfo(paymentMethod, paymentMethodType, cardBrandOpt, cardLast4Opt, cardBinOpt, cardExpiryMonthOpt, cardExpiryYearOpt, countryOpt, stateOpt, pinCodeOpt, isSavedPaymentMethodOpt, isCvcEmptyOpt) {
  let cardBrand = cardBrandOpt !== undefined ? cardBrandOpt : "NOTFOUND";
  let cardLast4 = cardLast4Opt !== undefined ? cardLast4Opt : "";
  let cardBin = cardBinOpt !== undefined ? cardBinOpt : "";
  let cardExpiryMonth = cardExpiryMonthOpt !== undefined ? cardExpiryMonthOpt : "";
  let cardExpiryYear = cardExpiryYearOpt !== undefined ? cardExpiryYearOpt : "";
  let country = countryOpt !== undefined ? countryOpt : "";
  let state = stateOpt !== undefined ? stateOpt : "";
  let pinCode = pinCodeOpt !== undefined ? pinCodeOpt : "";
  let isSavedPaymentMethod = isSavedPaymentMethodOpt !== undefined ? isSavedPaymentMethodOpt : false;
  let isCvcEmpty = isCvcEmptyOpt !== undefined ? isCvcEmptyOpt : true;
  let baseCardsFields = [
    [
      "cardBrand",
      CardUtils$OrcaPaymentPage.getCardBrandDisplayName(cardBrand)
    ],
    [
      "cardLast4",
      cardLast4
    ],
    [
      "cardBin",
      cardBin
    ],
    [
      "cardExpiryMonth",
      cardExpiryMonth
    ],
    [
      "cardExpiryYear",
      cardExpiryYear
    ],
    [
      "isCvcEmpty",
      isCvcEmpty
    ]
  ];
  let baseAddressFields = [
    [
      "country",
      country
    ],
    [
      "state",
      state
    ],
    [
      "pincode",
      pinCode
    ]
  ];
  let baseSavedPaymentField = [[
      "isSavedPaymentMethod",
      isSavedPaymentMethod
    ]];
  let basePaymentInfoFields = paymentMethod === "card" ? [[
        "paymentMethod",
        paymentMethod
      ]] : [
      [
        "paymentMethod",
        paymentMethod
      ],
      [
        "paymentMethodType",
        paymentMethodType
      ]
    ];
  let msg = paymentMethod !== "card" ? Belt_Array.concatMany([
      basePaymentInfoFields,
      baseAddressFields
    ]) : Belt_Array.concatMany([
      basePaymentInfoFields,
      baseAddressFields,
      baseCardsFields
    ]);
  let finalMsg = msg.filter(param => {
    let value = param[1];
    let match = Core__JSON.Classify.classify(value);
    if (typeof match !== "object") {
      return false;
    }
    switch (match.TAG) {
      case "Bool" :
        return true;
      case "String" :
        return Core__Option.getOr(Core__JSON.Decode.string(value), "") !== "";
      default:
        return false;
    }
  });
  emitMessage(Object.fromEntries(finalMsg.concat(baseSavedPaymentField)));
}

function useNonPiiAddressData() {
  let country = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.userCountry);
  let state = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.userAddressState).value;
  let pinCode = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.userAddressPincode).value;
  return {
    country: country,
    state: state,
    pinCode: pinCode
  };
}

function useEmitPaymentMethodInfo(paymentMethodName, paymentMethods, cardProps, expiryProps, cvcProps, skipCardOpt) {
  let skipCard = skipCardOpt !== undefined ? skipCardOpt : false;
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let match = useNonPiiAddressData();
  let cardBrand = cardProps.cardBrand;
  let cardNumber = cardProps.cardNumber;
  let pinCode = match.pinCode;
  let state = match.state;
  let country = match.country;
  let cardBin = CardUtils$OrcaPaymentPage.getCardBin(cardNumber);
  let cardLast4 = CardUtils$OrcaPaymentPage.getCardLast4(cardNumber);
  let isCvcEmpty = cvcProps.cvcNumber.length === 0;
  let isCardValid = Core__Option.getOr(cardProps.isCardValid, false);
  let isExpiryValid = Core__Option.getOr(expiryProps.isExpiryValid, false);
  let match$1 = CardUtils$OrcaPaymentPage.getExpiryDates(expiryProps.cardExpiry);
  let cardExpiryYear = match$1[1];
  let cardExpiryMonth = match$1[0];
  let shouldEmitCardInfo = isCardValid && isExpiryValid && paymentMethodName === "card";
  let emitPaymentMethodInfoWrapper = (paymentMethod, paymentMethodType) => {
    if (shouldEmitCardInfo) {
      return emitPaymentMethodInfo(paymentMethodName, paymentMethodType, CardUtils$OrcaPaymentPage.getCardType(cardBrand), cardLast4, cardBin, cardExpiryMonth, cardExpiryYear, country, state, pinCode, undefined, isCvcEmpty);
    } else {
      return emitPaymentMethodInfo(paymentMethod, paymentMethodType, undefined, undefined, undefined, undefined, undefined, country, state, pinCode, undefined, undefined);
    }
  };
  React.useEffect(() => {
    if (paymentMethodName.includes("_debit")) {
      emitPaymentMethodInfoWrapper("bank_debit", paymentMethodName);
    } else if (paymentMethodName.includes("_transfer")) {
      emitPaymentMethodInfoWrapper("bank_transfer", paymentMethodName);
    } else if (paymentMethodName === "card") {
      if (!skipCard) {
        emitPaymentMethodInfoWrapper("card", "debit");
      }
    } else {
      let finalOptionalPaymentMethodTypeValue = paymentMethods.filter(paymentMethodData => paymentMethodData.payment_method_types.filter(paymentMethodType => paymentMethodType.payment_method_type === paymentMethodName).length > 0)[0];
      if (finalOptionalPaymentMethodTypeValue !== undefined) {
        emitPaymentMethodInfoWrapper(finalOptionalPaymentMethodTypeValue.payment_method, paymentMethodName);
      } else {
        loggerState.setLogError("Payment method type not found", "PAYMENT_METHOD_TYPE_DETECTION_FAILED", undefined, undefined, undefined, undefined, undefined);
      }
    }
  }, [
    paymentMethodName,
    cardBrand,
    paymentMethods,
    isCardValid,
    isExpiryValid,
    isCvcEmpty,
    country,
    state,
    pinCode,
    skipCard
  ]);
}

function checkRenderOrComp(walletOptions, isShowOrPayUsing, isShowOrPayUsingWhileLoadingOpt) {
  let isShowOrPayUsingWhileLoading = isShowOrPayUsingWhileLoadingOpt !== undefined ? isShowOrPayUsingWhileLoadingOpt : false;
  if (walletOptions.includes("paypal") || isShowOrPayUsing) {
    return true;
  } else {
    return isShowOrPayUsingWhileLoading;
  }
}

function filterInstallmentPlansByPaymentMethod(installmentOptions, paymentMethod) {
  return Core__Option.getOr(Core__Option.map(installmentOptions.find(option => option.payment_method === paymentMethod), option => option.available_plans), []);
}

export {
  paymentMethodListValue,
  sdkConfigsValue,
  paymentManagementListValue,
  paymentListLookupNew,
  getDisplayNameAndIcon,
  getPaymentMethodName,
  isAppendingCustomerAcceptance,
  appendedCustomerAcceptance,
  getIsKlarnaSDKFlow,
  usePaypalFlowStatus,
  filterSavedMethodsByHiddenList,
  filterSavedMethodsByWalletReadiness,
  useGetPaymentMethodList,
  useStatesJson,
  getStateJson,
  sortCustomerMethodsBasedOnPriority,
  getSupportedCardBrands,
  checkIsCardSupported,
  emitMessage,
  emitPaymentMethodInfo,
  useNonPiiAddressData,
  useEmitPaymentMethodInfo,
  checkRenderOrComp,
  filterInstallmentPlansByPaymentMethod,
}
/* paymentMethodListValue Not a pure module */
